import { render } from "./2StatisticsPage.vue?vue&type=template&id=3019899c&ts=true"
import script from "./2StatisticsPage.vue?vue&type=script&lang=ts"
export * from "./2StatisticsPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyaho\\Documents\\Code Works\\AWebsiteRepositories\\VortexByReflex-Main\\Reflex-Repo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__